module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "customerInfo"
    }
  }, [_c('el-row', {
    staticClass: "clearfix",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('el-col', {
    staticClass: "fl",
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.backGo()
      }
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "fr",
    attrs: {
      "span": 1
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh",
    staticStyle: {
      "font-size": "25px",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.refresh()
      }
    }
  })])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "fl searthPart",
    staticStyle: {
      "width": "20%"
    }
  }, [_c('el-form', {
    ref: "returnForm",
    attrs: {
      "model": _vm.returnForm,
      "label-width": "80px",
      "label-position": _vm.labelPosition
    }
  }, [_c('p', {
    staticClass: "headerT"
  }, [_vm._v("客户信息")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "客户账号"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.returnForm.telephoneNo),
      callback: function($$v) {
        _vm.$set(_vm.returnForm, "telephoneNo", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "returnForm.telephoneNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "客户姓名"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.returnForm.customerName),
      callback: function($$v) {
        _vm.$set(_vm.returnForm, "customerName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "returnForm.customerName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "绑定微信"
    }
  }, [(_vm.returnForm.openId) ? _c('el-input', {
    attrs: {
      "disabled": true,
      "value": "是"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.returnForm.openId) ? _c('el-input', {
    attrs: {
      "disabled": true,
      "value": "否"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "注册时间"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.returnForm.createTime),
      callback: function($$v) {
        _vm.$set(_vm.returnForm, "createTime", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "returnForm.createTime"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "headerT"
  }, [_vm._v("地址信息")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.returnForm.customerName),
      callback: function($$v) {
        _vm.$set(_vm.returnForm, "customerName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "returnForm.customerName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系电话"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.returnForm.telephoneNo),
      callback: function($$v) {
        _vm.$set(_vm.returnForm, "telephoneNo", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "returnForm.telephoneNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "地址"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true,
      "type": "textarea"
    },
    model: {
      value: (_vm.returnForm.totalAddress),
      callback: function($$v) {
        _vm.$set(_vm.returnForm, "totalAddress", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "returnForm.totalAddress"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "fr",
    staticStyle: {
      "width": "78%"
    }
  }, [_c('el-card', {
    staticClass: "box-card fr",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.returnData,
      "border": "",
      "header-cell-style": {
        'text-align': 'center'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "orderNo",
      "width": "200",
      "label": "工单编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "150",
      "prop": "modelName",
      "label": "型号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "200",
      "label": "故障"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.faultSubclass), function(item, index) {
          return _c('span', {
            key: index,
            staticStyle: {
              "display": "block"
            }
          }, [_vm._v(_vm._s(item.faultSubclassName))])
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "150",
      "label": "下单时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(_vm._f("date")(scope.row.createTime)) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "200",
      "label": "预约时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.onsiteDate) + " " + _vm._s(scope.row.onsiteTimeStart) + " ~ " + _vm._s(scope.row.onsiteTimeEnd))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "250",
      "label": "客户信息"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "display": "block"
          }
        }, [_vm._v(_vm._s(scope.row.customerName) + " " + _vm._s(_vm._f("getTel")(scope.row.telephoneNo)))]), _vm._v(" "), (scope.row.provinceName != '上海市' && scope.row.provinceName != '北京市') ? _c('span', [_vm._v(_vm._s(scope.row.provinceName) + _vm._s(scope.row.cityName) + _vm._s(scope.row.countyName) + _vm._s(scope.row.address))]) : _c('span', [_vm._v(_vm._s(scope.row.provinceName) + _vm._s(scope.row.countyName) + _vm._s(scope.row.address))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "sum",
      "width": "100",
      "label": "工单状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(_vm._f("sysCodeFileter")(scope.row.adminStatus, 'admin_status')) + "\n                    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "sum",
      "width": "100",
      "label": "工单类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                        " + _vm._s(_vm._f("sysCodeFileter")(scope.row.serviceType, 'order_type')) + "\n                    ")]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "current-page": _vm.pages.page,
      "page-sizes": [10, 20, 50, 100],
      "page-size": _vm.pages.pageSize,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.pages.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-65727c6b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/customerManagement/customerInfo.vue
// module id = 1693
// module chunks = 0